"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loanInputFragment = exports.loanInputFields = void 0;
exports.loanInputFields = `
  agreementCode
  downPayment
  durationMonths
  ignoreCampaigns
  investedAmount
  isObjectDirectlyImported
  isObjectNew
  manualAdministrationFee
  manualNominalInterest
  objectGroupCode
  objectMake
  objectModel
  useDebtInsurance
`;
exports.loanInputFragment = `
  fragment loan on LoanInputDefaults {
    ${exports.loanInputFields}
  }
`;
//# sourceMappingURL=loan.js.map